import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PartnerAccountPage } from '../screens/admin/partner-billing/PartnerAccountPage';

const searchSchema = z.object({
  /** The statement shown with its lines; the newest when absent. */
  statement: z.string().uuid().optional().catch(undefined),
  /** Where the pages of companies and of statements start (the server's cursors). */
  companies: z.string().max(20).optional().catch(undefined),
  statements: z.string().max(20).optional().catch(undefined),
});

/** One paying account: its channel, standing, companies and statements (ADR-0036, section 7.1). */
export const Route = createFileRoute('/admin/partners/$account')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <PartnerAccountPage zoho={Route.useParams().account} />;
}
